import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "./auth/authApi";
import { setupListeners } from "@reduxjs/toolkit/query";
import { productsApi } from "./product/apiProducts";
import onboardingReducer from "./onboarding/onboardingSlice";

export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [productsApi.reducerPath]: productsApi.reducer,
    onboarding: onboardingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(authApi.middleware, productsApi.middleware),
});

setupListeners(store.dispatch);

// Define RootState type for use with useSelector
export type RootState = ReturnType<typeof store.getState>;
